import { Link, Outlet } from "react-router-dom";

function Home() {
  const logOutHandler = () => {
    localStorage.clear()
  }

  return (
    <section>
      <div className="row">
        <div className="col-2 text-light bg-dark" style={{ height: "auto" }}>
          <div>
            <h1 className="text-danger font-weight-bold font-italic mt-3">ACI</h1>
            <p>Hardware Store</p>
          </div>
          <div className="mt-5 mb-3">
            <Link className="text-light my-3" to={""}>Dashboard</Link>
          </div>
          <div className="mb-3">
            <Link className="text-light my-3" to={"categories"}>Categories</Link>
          </div>
          <div className="mb-3">
            <Link className="text-light my-3" to={"new-admin"}>Register Admin</Link>
          </div>
          <div className="mb-3">
            <Link className="text-light my-3" to={"login"} onClick={logOutHandler}>Sign Out</Link>
          </div>
        </div>

        <div className="col">
          <Outlet />
        </div>
      </div>
    </section>
  )
}

export default Home